"use client";
import "../../chunk-MMUBH76A.js";
const hasExternalWallet = (authLayout) => authLayout.find((layout) => layout.includes("EXTERNAL"));
const hasEmbeddedAuth = (authLayout) => authLayout.find((layout) => layout.includes("AUTH"));
export {
  hasEmbeddedAuth,
  hasExternalWallet
};
